///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
@Component({
    templateUrl: './AppViews/ShiftMaster/shiftMaster.html',

})

export class ShiftMasterComponent implements OnInit {
    public constants: Constants;
    public shiftMaster: any[] = [];
    public shiftMasterStatus: any[] = [];
    public filterShiftMasterStatus: any = "";
    public Search: any = "";
    public addShiftMasterData: any = {};
    public editShiftMasterData: any = {};
    public isAdd: boolean = true;
    active = true;
    public greater = false;
    public existsShiftMasterName: boolean = false;
    public showLoader = false;
    public isFormSubmitted: boolean = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
    }

    newForm() {
        this.active = false;
        this.greater = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.getShiftMaster();
    }

    ExportItems() {
        ExportToExcel(this.shiftMaster, "ShiftMaster",
            ["ShiftName", "StartTime", "EndTime", "LateMinutes", "HalfDayMinutes"],
            ["ShiftName", "StartTime", "EndTime", "LateMinutes", "HalfDayMinutes"]);
    }

    ngAfterViewInit() {
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    ngAfterViewChecked() {
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
    }
    public AddShiftMasterFormLoad() {
        $('#btnAddShiftMasterForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public OnGreater() {
        if (this.isAdd == true) {
            if (typeof this.addShiftMasterData.addShiftMasterLateMinutes != 'undefined' && typeof this.addShiftMasterData.addShiftMasterHalfDayMinutes != 'undefined') {
                if (Number(this.addShiftMasterData.addShiftMasterHalfDayMinutes) < Number(this.addShiftMasterData.addShiftMasterLateMinutes)) {
                    this.greater = true;
                }
                else {
                    this.greater = false;
                }
            }
        }
        else {
            if (typeof this.editShiftMasterData.editShiftMasterLateMinutes != 'undefined' && typeof this.editShiftMasterData.editShiftMasterHalfDayMinutes != 'undefined') {
                if (Number(this.editShiftMasterData.editShiftMasterHalfDayMinutes) < Number(this.editShiftMasterData.editShiftMasterLateMinutes)) {
                    this.greater = true;
                }
                else {
                    this.greater = false;
                }
            }
        }
    }

    public getShiftMaster() {
        this.showLoader = true;
        this._httpService.ajaxPost('ShiftMaster/GetShiftMaster', { "ShiftId": 0 }).subscribe(
            data => {
                this.shiftMaster = data["ShiftMasterList"];
                console.log(this.shiftMaster);
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public clearFilter() {
        this.Search = "";
    }

    public CancelAddShiftMaster() {
        this.addShiftMasterData = {};
        this.newForm();
        $('#addShiftMaster').modal('hide');
        this.isAdd = true;
        this.existsShiftMasterName = false;
    }

    public CancelEditShiftMaster() {
        this.existsShiftMasterName = false;
        this.editShiftMasterData = {};
        this.newForm();
        $('#editShiftMaster').modal('hide');
        this.isAdd = true;
    }

    public AddShiftMaster(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            if (this.greater == false) {
                this.existsShiftMasterName = false;
                this.shiftMaster.forEach(element => {
                    if (element.ShiftName.trim().toLowerCase() == this.addShiftMasterData.addShiftMasterName.trim().toLowerCase()) {
                        this.existsShiftMasterName = true;
                    }
                })
                if (!this.existsShiftMasterName) {
                    let objItem: any = {};
                    objItem.ShiftId = 0;
                    objItem.ShiftName = this.addShiftMasterData.addShiftMasterName;
                    objItem.StartTime = this.addShiftMasterData.addShiftMasterStartTime;
                    objItem.EndTime = this.addShiftMasterData.addShiftMasterEndTime;
                    objItem.LateMinutes = this.addShiftMasterData.addShiftMasterLateMinutes;
                    objItem.HalfDayMinutes = this.addShiftMasterData.addShiftMasterHalfDayMinutes;
                    this.addEditShiftMaster(objItem);
                    $('#addShiftMaster').modal('hide');
                    this.addShiftMasterData = {};
                    this.isAdd = true;
                }
            }
        }
    }

    public EditShiftMaster(item: any) {
        $('#btnEditShiftMasterForm').trigger('click');
        this.isAdd = false;
        this.EditShiftMasterChange(item.ShiftId);
    }

    public EditShiftMasterChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.shiftMaster.filter((shiftMaster) => shiftMaster.ShiftId == itemId)[0]));
        this.editShiftMasterData.editShiftId = objItem.ShiftId;
        this.editShiftMasterData.editShiftMasterName = objItem.ShiftName;
        this.editShiftMasterData.editShiftMasterStartTime = objItem.StartTime;
        this.editShiftMasterData.editShiftMasterEndTime = objItem.EndTime;
        this.editShiftMasterData.editShiftMasterLateMinutes = objItem.LateMinutes;
        this.editShiftMasterData.editShiftMasterHalfDayMinutes = objItem.HalfDayMinutes;
    }

    public UpdateShiftMaster(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            if (this.greater == false) {
                this.existsShiftMasterName = false;
                this.shiftMaster.forEach(element => {
                    if (element.ShiftId != this.editShiftMasterData.editShiftId && element.ShiftName.trim().toLowerCase() == this.editShiftMasterData.editShiftMasterName.trim().toLowerCase()) {
                        this.existsShiftMasterName = true;
                    }
                })
                if (!this.existsShiftMasterName) {
                    let objItem: any = {};
                    objItem.ShiftId = this.editShiftMasterData.editShiftId;
                    objItem.ShiftName = this.editShiftMasterData.editShiftMasterName;
                    objItem.StartTime = this.editShiftMasterData.editShiftMasterStartTime;
                    objItem.EndTime = this.editShiftMasterData.editShiftMasterEndTime;
                    objItem.LateMinutes = this.editShiftMasterData.editShiftMasterLateMinutes;
                    objItem.HalfDayMinutes = this.editShiftMasterData.editShiftMasterHalfDayMinutes;
                    this.addEditShiftMaster(objItem);
                    $('#editShiftMaster').modal('hide');
                    this.editShiftMasterData = {};
                    this.isAdd = true;
                }
            }
        }
    }

    addEditShiftMaster(objItem) {
        this.showLoader = true;
        this._httpService.ajaxPost('ShiftMaster/AddUpdateShiftMaster', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0];
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getShiftMaster();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ShiftMaster/shiftMaster.component.ts
 **/